import { deleteNotebook, deleteNotice, getFileOrigin, getPayments, url, getDiscountOne, getDiscounts, postPayments, putPayments, postDiscounts, putDiscounts, postReceipt} from "api/api";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import { DocIcon, colors } from "styles/global-styles";
import { ClassInfo, DiscountInfo, NotebookInfo, NoticeInfo, PaymentInfo, provinceInfo, ReceiptInfo, ReceiptTotalInfo, StudentInfo } from "type/type";
import { AttendanceAdmitAbsentType, IsDisabledType, MONTHS, PayMethodType, PaymentDetailType, PromotionType, ReceiptDiscount, ReceiptPaymentType, aesCBCDecrypt, changeNotebookType, create_user_type_PARENT, create_user_type_TEACHER, formatCurrency, formattedDateHyphenYYYYMMDD, formattedDateTime, formattedSelectOption, formattedSelectOptionNotAll, getCurrentDateTime } from "utils/commonUtils";
import {
  AttachFileWrap,
  SolidPrimaryBtn,
  SolidPrimarySubBtn,
  SolidRedBtn,
} from "./button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { UserClassContext } from "pages/notice/Notice";
import { MultipleSelectOption, SelectOption } from "./input/Input";
import { CustomDatePickerWrap } from "./layout/Layout";
import ReactDatePicker from "react-datepicker";
import { addMonths, getMonth, getYear, subYears } from "date-fns";
import { TooltipIcon } from "./common/Icon";
import {useLoginUserInfo} from "../redux/hook/useLoginUserInfo";

// 모달
const defaultOverlay = {
  backgroundColor: "rgb(0 0 0 / 50%)",
  width: "100%",
  height: "100vh",
  zIndex: "22",
  overflow: "auto"
}
const defaultContent = {
  backgroundColor: "#FFFFFF",
  width: "50vw",
  minWidth: "600px",
  maxWidth: "800px",
  height: "100%",
  minHeight: "280px",
  maxHeight: "80%",
  borderRadius: "1rem",
  left: 0,
  right: 0,
  inset: "0px 0px",
  margin: "70px auto",
  overflow: "hidden",
}

// TODO: 이걸 메인으로 갈 예정
const defaultModalStyle = {
  overlay: defaultOverlay,
  content: defaultContent,
};
// short version 모달 스타일
const shortCustomStyles = {
  overlay: defaultOverlay,
  content: {
    ...defaultContent,
    height: "50%",
    minHeight: "280px",
    maxHeight: "480px",
    minWidth: "400px",
    maxWidth: "500px",
  }
};
// mini version 모달 스타일
const miniCustomStyles = {
  overlay: defaultOverlay,
  content: {
    ...defaultContent,
    width: "380px",
    minWidth: "auto",
    maxWidth: "none",
    height: "420px",
    minHeight: "auto",
    maxHeight: "none",
  }
};


const defaultContentStyles = {
  backgroundColor: "#FFFFFF",
  width: "50%",
  minWidth: "240px",
  maxWidth: "580px",
  borderRadius: "1rem",
  left: 0,
  right: 0,
  margin: "auto",
}

const detailCustomStyles = {
  overlay: defaultOverlay,
  content: {
    ...defaultContentStyles,
    overflow: "hidden",
    height: "100%",
    minHeight: "280px",
    maxHeight: "80%",
  },
};
const notOverflowHiddenCustomStyles = {
  overlay: defaultOverlay,
  content: {
    ...defaultContentStyles,
    overflow: "none",
    height: "100%",
    minHeight: "280px",
    maxHeight: "80%",
  },
};

// 이걸로 메인 예정
const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  header {
    font-family: var(--font-nanumSquare-acB);
    font-size: 1.125rem;
    height: 2.875rem;
    padding: 0.5rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    h3 {
      margin: 0;
    }
    img:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
  section {
    height: calc(100% - 5.125rem);
    overflow: auto;
    margin: 1rem 0;

    .main-title {
      padding: 0.5rem 0 1rem;
      border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    }
  }
  main {
    padding: 0 0.25rem 1rem 0.25rem;
    color: ${({ theme }) => theme.newTheme.default.textGray};

    // 모달 내 table
    .modal-list-table {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
    }
    .modal-list-table-header {
      position: sticky;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: ${({theme}) => theme.newTheme.table.tableHeadBg};
      color: ${({theme}) => theme.newTheme.table.tableHeadText};
      font-family: var(--font-nanumSquare-acB);
      // border-radius: 0.5rem;
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
      > div {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        &:first-of-type {
          display: flex;
          justify-content: center;
        }
      }
    }
  }
  article {
    .sub-title {
      font-size: 1rem;
      font-family: var(--font-nanumSquare-acB);
    }
    padding: 1rem 0;
    color: ${({ theme }) => theme.newTheme.default.text};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    line-height: 1.5rem;
    white-space: break-spaces;
  }

  .default-bottom-btn {
    height: 2.25rem;
    margin-top: auto;
  }
  .text-red {
    color: ${({theme}) => theme.newTheme.default.error};
  }
  .text-yellow {
    color: ${colors.yellow};
  }
  .text-gray {
    color: ${colors.darkGray};
  }
  .text-green {
    color: ${colors.green};
  }
  .text-blue {
    color: ${colors.blue};
  }
  .text-vermillion {
    color: ${colors.vermillion};
  }  
`;



const CommonModalContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  header {
    font-family: var(--font-nanumSquare-acB);
    height: 3.5rem;
    padding: 0.75rem 0.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    h3 {
      margin: 0;
      font-size: 1.125rem;
    }
    img:hover {
      cursor: pointer;
    }
  }
  section {
    max-height: calc(100% - 6rem);
    height: 100%;
    overflow: hidden;
    padding: 1rem;
    border: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    border-radius: 0.5rem;
    .title-container {
      max-height: 5.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
      nav {
        display: flex;
        justify-content: space-between;
        color: ${({ theme }) => theme.newTheme.default.accent};
      }
      .main-title {
        font-size: 1.25rem;
      }
      .etc-info-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .content-container {
      height: calc(100% - 5.5rem);
      padding: 1rem 0.5rem;
      color: ${({ theme }) => theme.newTheme.default.text};
      display: flex;
      flex-direction: column;
      gap: 1rem;
      line-height: 1.5rem;
      overflow: auto;
      .content-text-wrap {
        white-space: pre-line;
        max-height: 40vh;
      }
    }
  }
  // 0 행사안내
  .text-vermillion {
    color: ${colors.vermillion};
  }
  // 1 준비물
  .text-green {
    color: ${colors.green};
  }
  // 2 수업내용
  .text-blue {
    color: ${colors.blue};
  }
  // 3 생활
  .text-yellow {
    color: ${colors.yellow};
  }
  // 4 기타
  .text-gray {
    color: ${colors.lightGray};
  }
`;
const RadioModalContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  header {
    font-family: var(--font-nanumSquare-acB);
    height: 3.5rem;
    padding: 0.75rem 0.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    h3 {
      margin: 0;
      font-size: 1.125rem;
    }
    img:hover {
      cursor: pointer;
    }
  }
  .sub-header {
    padding: 0.75rem 0.25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.25rem;
    .attendance {
      font-weight: 600;
      color: ${colors.green};
    }
    .absent {
      font-weight: 600;
      color: ${colors.vermillion};
    }
  }
  section {
    max-height: calc(100% - 6rem);
    height: 100%;
    overflow: hidden;
    padding: 1rem;
    border: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      min-height: 3rem;
      label {
        min-width: 10rem;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  input[type="radio"] {
    -webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
    -moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
    appearance: none; // 기본 브라우저에서 기본 스타일 제거
    width: 1.25rem;
    height: 1.25rem;
    margin: 0.25rem;
    border-radius: 50%;
    padding: 0.25rem;
    border: 1px solid ${({ theme }) => theme.newTheme.border.thirdBd};
    background-color: ${({ theme }) => theme.rootWhite};
    outline: none;
    cursor: pointer;
    &:checked {
      border: 3px solid ${({ theme }) => theme.rootWhite}; // 테두리가 아닌, 테두리와 원 사이의 색상
      background-color: ${({ theme }) =>
        theme.newTheme.default.primary}; // 체크 시 내부 원으로 표시될 색상
      box-shadow: 0 0 0 1px ${({ theme }) => theme.newTheme.default.primary};
    }
  }
  button {
    width: 100%;
  }
`;
const ButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.5rem 0;
`;
// 상세보기 - 파일이 있는 경우 파일 부분
export const DocFileWrap = styled.details`
  summary {
    display: flex;
    padding: 0.75rem;
    border-radius: 0.5rem;
    background-color: #f2f2f2;
    &:focus-visible {
      outline-color: ${({ theme }) => theme.newTheme.default.accent};
    }
  }
  > div {
    display: flex;
  }
  &[open] {
    border-radius: 0.5rem;
    background-color: #f2f2f2;
    > div:hover {
      background-color: #f7f7f7;
    }
  }
`;
// 상세보기 - 이미지가 있는 경우 이미지 부분
export const ImageFileWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  .image-wrap {
    width: 15rem;
    height: 15rem;
    aspect-ratio: 1 / 1;
    position: relative;
    div {
      position: absolute;
      bottom: 0.5rem;
      display: flex;
      width: 100%;
      justify-content: center;
      p {
        background-color: rgb(26 26 26 / 80%);
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        color: ${({ theme }) => theme.rootWhite};
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: absolute;
      display: none;
      &.show {
        display: inline-block;
      }
    }
  }
  .page-btn {
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
    &.disabled {
      opacity: 0.3;
      cursor: default;
    }
  }
`;

// 수납(기본수납) 모달 - TODO: 공통으로 뺄 예정
const CommonModalContainer2 = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  header {
    font-family: var(--font-nanumSquare-acB);
    height: 3.5rem;
    padding: 0.75rem 0.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    h3 {
      margin: 0;
      font-size: 1.125rem;
    }
    img:hover {
      cursor: pointer;
    }
  }
  input[type="radio"] {
    -webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
    -moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
    appearance: none; // 기본 브라우저에서 기본 스타일 제거
    width: 1.25rem;
    height: 1.25rem;
    margin: 0.25rem;
    border-radius: 50%;
    padding: 0.25rem;
    border: 1px solid ${({ theme }) => theme.newTheme.border.thirdBd};
    background-color: ${({ theme }) => theme.rootWhite};
    outline: none;
    cursor: pointer;
    &:checked {
      border: 3px solid ${({ theme }) => theme.rootWhite}; // 테두리가 아닌, 테두리와 원 사이의 색상
      background-color: ${({ theme }) =>
        theme.newTheme.default.primary}; // 체크 시 내부 원으로 표시될 색상
      box-shadow: 0 0 0 1px ${({ theme }) => theme.newTheme.default.primary};
    }
  }
  input[type="checkbox"] {
    appearance: none;
    width: 1.25rem;
    height: 1.25rem;
    background-color: ${({ theme }) => theme.newTheme.textField.defaultBg};
    border-radius: 0.25rem;
    &:checked {
      background-color: ${({ theme }) => theme.newTheme.default.accent};
      &::before {
        content: url("/image/icon/check.svg");
        color: ${({ theme }) => theme.newTheme.text.btnText_w};
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        height: inherit;
      }
    }
  }
`;
// 이것도 공통으로 뺄 예정
const CommonModalContent = styled.section`
  max-height: calc(100% - 6rem);
  height: 100%;
  overflow-y: auto;
  padding: 0.5rem 1rem;
  > div.flex-c {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .default-info-box {
    background-color: ${({ theme }) => theme.newTheme.textField.defaultBg};
    padding: 1rem;
    border-radius: 0.5rem;
  }
  summary {
    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  }
`;
const InputWrap = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  .required_value::after {
    position: absolute;
    content: "*";
    color: ${({theme}) => theme.newTheme.default.error};
  }
`;
const InputWrapC = styled(InputWrap)`
  flex-direction: column;
  gap: 0.5rem;
`;
const InputWrapR = styled(InputWrap)`
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`;

export type ModalType = "" |
                        "deviceCreate" | "deviceModify" |
                        "siteModify" |
                        "classCreate" | "classModify" | "excelMoveClass" |
                        "addStudent" |
                        "showNotebook" |
                        "createTeacher" | "updateTeacher" |
                        "createStudent" | "updateStudent" | "excelCreateAllStudent" |
                        "createBus" | "updateBus" |
                        "parentInfo" |
                        "updateDdns";

export type ModalTitle = "" |
                          "전자 출결 기기 등록" | "전자 출결 기기 수정" |
                          "학교 정보 수정" |
                          "반 신규 등록" | "반 정보 수정" | "반 일괄 이동" |
                          "학생 추가" |
                          "알림장 상세내용" |
                          "선생님 신규 등록" | "선생님 정보 수정" |
                          "학생 신규 등록" | "학생 정보 수정" | "엑셀 파일로 학생 일괄 등록" |
                          "신규 차량 등록" | "차량 정보 수정" |
                          "학부모 정보" |
                          "DDNS 정보 수정";
                          



/**
 * 짧은 모달 - button 없음
 */
export interface ShortModalPropsInterface {
  isOpen: boolean;
  isClose: Function;
  title: string;
  content: React.ReactNode;
  type?: string;
}
export function ShortModalComponent(ModalPropsInterface: ShortModalPropsInterface) {
  const { isOpen, isClose, title, content } = ModalPropsInterface;

  function closeModal() {
    isClose(false);
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={shortCustomStyles}
      contentLabel="Short Modal"
    >
      <ModalContent>
        <header>
          <h3>{title}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <section>
          <main> {content}</main>
        </section>
      </ModalContent>
    </Modal>
  );
}
// 앱 다운로드용 modal
export function MiniModalComponent(ModalPropsInterface: ShortModalPropsInterface) {
  const { isOpen, isClose, title, content } = ModalPropsInterface;

  function closeModal() {
    isClose(false);
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={miniCustomStyles}
      contentLabel="Mini Modal"
    >
      <ModalContent>
        <header>
          <h3>{title}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <section>
          <main style={{padding: '0 2rem', height: '100%'}}> {content}</main>
        </section>
      </ModalContent>
    </Modal>
  );
}

/**
 * 기본 모달 - 버튼 분리
 */
//모달 인터페이스
export interface ModalPropsInterface {
  isOpen: boolean;
  isClose: Function;
  title: ModalTitle;
  content: React.ReactNode;
  button: React.ReactNode;
  type: ModalType;
}

export function DefaultModalComponent(ModalPropsInterface: ModalPropsInterface) {
  const { isOpen, isClose, title, content, button, type } = ModalPropsInterface;

  function closeModal() {
    isClose(false);
  }

  return (
      <Modal
          isOpen={isOpen}
          onRequestClose={closeModal}
          ariaHideApp={false}
          style={defaultModalStyle}
          contentLabel="Agreement Modal"
      >
        <ModalContent>
          <header>
            <h3>{title}</h3>
            <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
          </header>
          <section>
            <main> {content}</main>
          </section>
          {button}
        </ModalContent>
      </Modal>
  );
}





type FileListType = {
  file_name: string;
  file_path: string;
  mime_type: string;
  origin_file_name: string;
  notebook_id?: number;
  notice_id?: number;
};
/**
 * 알림장 상세내용 모달
 * - 이미지가 있는 경우 슬라이드로 보여주기
 * - 문서가 있는 경우 문서 이름, 다운로드 가능하도록 보여주기
 * @param param0
 * @returns
 */
const NoticeDetailModalWrap = ({ notice }: { notice: NoticeInfo }) => {
  // 전역 데이터
  const { classData, userData } = useContext(UserClassContext);
  const { site_id, title, content, class_list, reg_date } = notice;
  // const user_name_data = userData.find(user => user.id === notice.user_id);
  // const user_name = user_name_data !== undefined ? aesCBCDecrypt(user_name_data.name) : "-";

  const URL = url;
  // 이미지/문서 분리
  const imageUrlListRef = useRef<FileListType[]>([]);
  const docUrlListRef = useRef<FileListType[]>([]);
  if (notice.file_list.length) {
    imageUrlListRef.current = [];
    docUrlListRef.current = [];
    const { file_list } = notice;
    file_list.forEach((file: FileListType) => {
      if (/(jpg|jpeg|png)/i.test(file.mime_type))
        imageUrlListRef.current.push({
          file_name: file.file_name,
          file_path: file.file_path,
          mime_type: file.mime_type,
          origin_file_name: file.origin_file_name,
          notice_id: file.notice_id,
        });
      if (/(pdf|xlsx|doc|pptx)/i.test(file.mime_type))
        docUrlListRef.current.push({
          file_name: file.file_name,
          file_path: file.file_path,
          mime_type: file.mime_type,
          origin_file_name: file.origin_file_name,
          notice_id: file.notice_id,
        });
    });
  }
  // console.log(docUrlListRef);
  // 이미지가 있는 경우 < > 넘길 때 index
  const imageMaxNum = imageUrlListRef.current.length;
  const [imageNum, setImageNum] = useState(1);
  function increaseNum() {
    if (imageNum !== imageMaxNum) setImageNum((prev) => prev + 1);
  }
  function decreaseNum() {
    if (imageNum !== 1) setImageNum((prev) => prev - 1);
  }
  const docMaxNum = docUrlListRef.current.length;
  // 이미지/문서 불러오기API 후 List 저장
  // 다운로드 클릭 시 파일 다운로드
  const downloadDoc = async (index: number) => {
    const { file_name, origin_file_name } = docUrlListRef.current[index];
    const result = await getFileOrigin(file_name); // blob
    const url = window.URL.createObjectURL(result);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", origin_file_name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <section>
      <div className="title-container">
        <nav>
          <p>공지사항</p>
        </nav>
        <div className="main-title">
          <p>{title}</p>
        </div>
        <div className="etc-info-wrap">
          <p>
            {class_list.length === 0 ||
            classData.length === class_list.length ? (
              <span>전체</span>
            ) : (
              <span>
                {class_list.map((c, index) =>
                  index === 0 ? `${c.name}` : `/${c.name}`
                )}
              </span>
            )}
          </p>
          <span>등록일자: {reg_date.substring(0, reg_date.length - 3)}</span>
        </div>
      </div>
      <article className="content-container">
        {imageUrlListRef.current.length > 0 ? (
          <ImageFileWrap>
            <img
              src="/image/icon/arrow_left.svg"
              alt="arrow-left"
              className={`page-btn ${imageNum === 1 ? "disabled" : ""}`}
              onClick={decreaseNum}
            />
            <div className="image-wrap">
              {imageUrlListRef.current.map((image: FileListType, index) => (
                <img
                  key={index}
                  src={`${URL}/v1/sites/${site_id}/file?file_name=${image.file_name}`}
                  className={index + 1 === imageNum ? "show" : ""}
                  alt={image.origin_file_name}
                />
              ))}
              <div>
                <p>
                  <span>{imageNum}</span>
                  <span>/ {imageMaxNum}</span>
                </p>
              </div>
            </div>
            <img
              src="/image/icon/arrow_right.svg"
              alt="arrow-right"
              className={`page-btn ${
                imageNum === imageMaxNum ? "disabled" : ""
              }`}
              onClick={increaseNum}
            />
          </ImageFileWrap>
        ) : null}
        {docUrlListRef.current.length ? (
          <DocFileWrap>
            <summary>
              <p>첨부파일 ({docMaxNum})</p>
            </summary>
            {docUrlListRef.current.map((doc: FileListType, index) => (
              <AttachFileWrap key={index} data-notice-id={doc.notice_id}>
                <DocIcon className={doc.mime_type} />
                <p>
                  {doc.origin_file_name.length - 5 > 12
                    ? `${doc.origin_file_name.substring(
                        0,
                        12
                      )}...${doc.origin_file_name.substring(
                        doc.origin_file_name.lastIndexOf(".")
                      )}`
                    : doc.origin_file_name.length}
                </p>
                <div className="save-doc" onClick={() => downloadDoc(index)}>
                  <img src="/image/icon/save.svg" alt="close" />
                </div>
              </AttachFileWrap>
            ))}
          </DocFileWrap>
        ) : null}
        <div className="content-text-wrap">
          <p>{content}</p>
        </div>
      </article>
    </section>
  );
};

// 상세보기 모달
/**
 *
 * @type detail 상세내용(제목, 내용)
 * @returns
 */
export function AttendanceAdmitAbsent({
  isOpen,
  content,
  isResponse,
  isClose,
  emptyMsg,
}: {
  isOpen: boolean;
  content: any;
  isResponse: Function;
  isClose: Function;
  emptyMsg?: string;
}) {
  const etcCheckRef = useRef<HTMLInputElement>(null);
  const etcTextRef = useRef<HTMLInputElement>(null);
  const [checkValue, setCheckValue] = useState("");
  // 체크여부 확인
  const [checkedItem, setCheckedItem] = useState<boolean[]>(
    new Array(AttendanceAdmitAbsentType.length).fill(false)
  );
  const [etcCheckValue, setEtcCheckValue] = useState("");

  function handleInputChange(
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) {
    const { id, name, value } = event.target;
    if ("reason-etc-text" === name) setEtcCheckValue(value);
    else setEtcCheckValue("");
    setCheckedItem((prevData) => {
      const newData = prevData.map((prev) => false);
      newData[index] = true;
      return newData;
    });
    setCheckValue(id);
  }
  // 인정결석 사유 전달
  function responseData() {
    if (
      (checkedItem[checkedItem.length - 1] && !etcCheckValue) ||
      etcCheckValue === "기타"
    ) {
      alert("정확한 기타 사유를 작성해주세요.");
      etcTextRef.current?.focus();
      return;
    }
    // 기타를 선택한 경우, 나머지를 선택한 경우
    if (checkedItem[checkedItem.length - 1])
      isResponse(content.index, etcCheckValue);
    else isResponse(content.index, checkValue);
  }
  function closeModal() {
    isClose(false);
  }

  useEffect(() => {
    setCheckedItem((prevItem) => {
      if (content.reason === "")
        return new Array(AttendanceAdmitAbsentType.length).fill(false);
      else {
        let reasonValue =
          AttendanceAdmitAbsentType.find(
            (reason) => content.reason === reason.label
          )?.value || "";
        let check = 0;
        return AttendanceAdmitAbsentType.map((type, index) => {
          if (type.value === reasonValue) {
            check = 1;
            return true;
          }
          // 마지막 index까지 해당되는 type이 없는 경우 기타
          if (index === AttendanceAdmitAbsentType.length - 1 && check === 0) {
            setEtcCheckValue(content.reason);
            return true;
          } else return prevItem[index];
        });
      }
    });
  }, [content]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={defaultModalStyle}
      contentLabel="detail Modal"
    >
      <RadioModalContainer>
        <header>
          <h3>인정결석 사유 선택</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <p className="sub-header">
          <span>
            인정결석 시 사유를 반드시 선택해 주셔야{" "}
            <span className="attendance">출석</span>으로 인정 됩니다.
          </span>
          <span>
            사유 미선택시 <span className="absent">결석</span>처리 됩니다.
          </span>
        </p>
        <section>
          {AttendanceAdmitAbsentType.map((type, index) =>
            "reason_etc" !== type.value ? (
              <div key={type.value}>
                <input
                  type="radio"
                  name="admit-absent-reason"
                  id={type.value}
                  onChange={(event) => handleInputChange(event, index)}
                  checked={checkedItem[index]}
                />
                <label htmlFor={type.value}>{type.label}</label>
              </div>
            ) : (
              <div key={type.value}>
                <input
                  type="radio"
                  name="admit-absent-reason"
                  id={type.value}
                  onChange={(event) => handleInputChange(event, index)}
                  checked={checkedItem[index]}
                  ref={etcCheckRef}
                />
                <label htmlFor={type.value}>{type.label}</label>
                <input
                  type="text"
                  name="reason-etc-text"
                  value={etcCheckValue}
                  disabled={!checkedItem[index]}
                  placeholder="기타 사유를 입력해주세요."
                  ref={etcTextRef}
                  onChange={(event) => handleInputChange(event, index)}
                  style={{width: 'calc(100% - 14rem)'}}
                />
              </div>
            )
          )}
        </section>
        <ButtonWrap>
          <SolidPrimaryBtn
            type="button"
            className="default-btn"
            onClick={responseData}
          >
            선택완료
          </SolidPrimaryBtn>
        </ButtonWrap>
      </RadioModalContainer>
    </Modal>
  );
}
/**
 *
 * @type detail 상세내용(제목, 내용)
 * @returns
 */
export function CommonModalComponent({
  type,
  isOpen,
  header,
  content,
  isRefresh,
  isClose,
  emptyMsg,
}: {
  type: string;
  isOpen: boolean;
  header: string;
  content: any | any[];
  isRefresh: Function;
  isClose: Function;
  emptyMsg?: string;
}) {
  // 수정/삭제
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  function handlePutNotebook(notebookIdx: number) {
    navigate(`${pathName}/${notebookIdx}`, { state: content });
  }
  async function handleDeleteNotebook(index: number) {
    if (!index) return;
    let isDelete = window.confirm(
      `해당공지사항을 삭제하시겠습니까?`
    );
    if (!isDelete) return;

    let result: any;
    if (type === "noticeDetail") result = await deleteNotice(index);

    if (result.code === 200) {
      const goList = result.code === 200 ? true : false;
      if (result?.message) alert(result.message);
      if (goList) {
        isClose(false);
        isRefresh(true);
      }
    } else {
      alert(result.message);
      return;
    }
  }

  function closeModal() {
    isClose(false);
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={detailCustomStyles}
      contentLabel="detail Modal"
    >
      <CommonModalContainer>
        <header>
          <h3>{header}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        {!content ? (
          <section>
            <div>
              <p className="sub-title">{emptyMsg}</p>
            </div>
          </section>
        ) : type === "noticeDetail" ? (
          <NoticeDetailModalWrap notice={content} />
        ) : null}
        <ButtonWrap>
          <SolidPrimarySubBtn
            type="button"
            className="default-btn "
            onClick={() => handlePutNotebook(content.id)}
          >
            수정
          </SolidPrimarySubBtn>
          <SolidRedBtn
            type="button"
            className="default-btn "
            onClick={() => handleDeleteNotebook(content.id)}
          >
            삭제
          </SolidRedBtn>
        </ButtonWrap>
      </CommonModalContainer>
    </Modal>
  );
}


/**
 * 수납 항목 관리 모달
 * @isOpen 모달 open true/false
 * @type 등록 'create' / 수정 'edit'
 * @content 할인/프로모션 object
 * @isClose 모달 close true/false
 * @isSuccess 등록 및 수정 success true/false
 */
export function PaymentModalComponent({
  isOpen,
  type,
  content,
  setPaymentOne,
  isClose,
  isSuccess,
  emptyMsg,
}: {
  isOpen: boolean;
  type: string;
  content: PaymentInfo;
  setPaymentOne: Function;
  isClose: Function;
  isSuccess: Function;
  emptyMsg?: string;
}) {
  const { selectSiteId } = useLoginUserInfo();
  // console.log("selectSiteId ", selectSiteId);
  // console.log("content ", content);
  const [receiptObj, setReceiptObj] = useState(content);
  const defaultReceiptObj: PaymentInfo = {
    id: 0,
    site_id: selectSiteId,
    name: "",
    type: 0,
    price: 0,
    payment_type: 0,
    discount_status: 0,
    etc: "",
    is_disabled: 0,
    age_group: 0,
  };
  const paymentType = PaymentDetailType;
  const receiptPaymentType = ReceiptPaymentType;
  const receiptDiscount = ReceiptDiscount;
  const isDisabledType = IsDisabledType;
  // 수정/삭제
  const headTitle = type === "create" ? `기본수납 신규등록` : `기본수납 수정`;

  async function handleCreateOne() {
    // setPaymentOne
    const { id, ...data } = receiptObj;
    if (data.name === "" || !data.payment_type || !data.price || !data.type) {
      window.alert('필수항목을 다 입력해주세요.');
      return;
    }
    if (type === "create") {
      // 신규 등록
      const postPaymentRes = await postPayments(data);
      if (postPaymentRes.code === 200) {
        isClose(false);
        setReceiptObj(defaultReceiptObj);
        isSuccess(true);
        // 성공 결과 넘기기
      } else throw new Error("postPayments API error ", postPaymentRes.message);
    }
    else {
      // 수정
      const putPaymentRes = await putPayments(data, id);
      if (putPaymentRes.code === 200) {
        isClose(false);
        setReceiptObj(defaultReceiptObj);
        isSuccess(true);
        // 성공 결과 넘기기
      } else throw new Error("postPayments API error ", putPaymentRes.message);
    }
  }

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    // console.log(name, value);
    if (name === "price") {
      const regex = /\D+/gi;
      const removedCommaValue = Number(value.replaceAll(",", ""));
      if (!regex.test(String(removedCommaValue))) {
        setReceiptObj({ ...receiptObj, [name]: removedCommaValue });
      }
    } else if (
      name === "type" ||
      name === "payment_type" ||
      name === "discount_status" ||
      name === "is_disabled" ||
      name === "age_group"
    )
      setReceiptObj((prev) => ({ ...prev, [name]: Number(value) }));
    else setReceiptObj((prev) => ({ ...prev, [name]: value }));
  };
  function closeModal() {
    isClose(false);
    setReceiptObj(defaultReceiptObj);
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={detailCustomStyles}
      contentLabel="detail Modal"
    >
      <CommonModalContainer2>
        <header>
          <h3>{headTitle}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <CommonModalContent>
          <div className="flex-c">
            <div className="default-info-box">
              <InputWrapC>
                <p>사용 여부</p>
                <InputWrapR>
                  {isDisabledType.map((d) => (
                    <InputWrapR key={d.value}>
                      <input
                        type="radio"
                        id={`is_disabled${d.value}`}
                        name="is_disabled"
                        value={d.value}
                        onChange={(event) => handleInputChange(event)}
                        checked={receiptObj.is_disabled === d.value}
                      />
                      <label htmlFor={`is_disabled${d.value}`}>{d.label}</label>
                    </InputWrapR>
                  ))}
                </InputWrapR>
              </InputWrapC>
            </div>
            <InputWrapC>
              <label htmlFor="name" className="required_value">수납명</label>
              <input
                type="text"
                name="name"
                value={receiptObj.name}
                onChange={(event) => handleInputChange(event)}
                placeholder="수납명 입력"
              />
            </InputWrapC>
            <InputWrapC>
              <p className="required_value">수납 종류</p>
              <InputWrapR>
                {paymentType.map((p) => (
                  <InputWrapR key={p.value}>
                    <input
                      type="radio"
                      id={`type_${p.value}`}
                      name="type"
                      value={p.value}
                      onChange={(event) => handleInputChange(event)}
                      checked={receiptObj.type === p.value}
                    />
                    <label htmlFor={`type_${p.value}`}>{p.label}</label>
                  </InputWrapR>
                ))}
              </InputWrapR>
            </InputWrapC>
            <InputWrapC>
              <label htmlFor="price" className="required_value">금액(원)</label>
              <input
                type="text"
                name="price"
                value={formatCurrency(receiptObj.price)}
                onChange={(event) => handleInputChange(event)}
                placeholder="금액 입력"
              />
            </InputWrapC>
            <InputWrapC>
              <p className="required_value">수납 구분</p>
              <InputWrapR>
                {receiptPaymentType.map((r) => (
                  <InputWrapR key={r.value}>
                    <input
                      type="radio"
                      id={`payment_type_${r.value}`}
                      name="payment_type"
                      value={r.value}
                      onChange={(event) => handleInputChange(event)}
                      checked={receiptObj.payment_type === r.value}
                    />
                    <label htmlFor={`payment_type_${r.value}`}>{r.label}</label>
                  </InputWrapR>
                ))}
              </InputWrapR>
            </InputWrapC>
            <InputWrapC>
              <p>할인 적용</p>
              <InputWrapR>
                {receiptDiscount.map((d) => (
                  <InputWrapR key={d.value}>
                    <input
                      type="radio"
                      id={`discount_status_${d.value}`}
                      name="discount_status"
                      value={d.value}
                      onChange={(event) => handleInputChange(event)}
                      checked={receiptObj.discount_status === d.value}
                    />
                    <label htmlFor={`discount_status_${d.value}`}>
                      {d.label}
                    </label>
                  </InputWrapR>
                ))}
              </InputWrapR>
            </InputWrapC>
            <InputWrapC>
              <label htmlFor="etc">비고</label>
              <input
                type="text"
                name="etc"
                value={receiptObj.etc}
                onChange={(event) => handleInputChange(event)}
                placeholder="내용 입력"
              />
            </InputWrapC>
          </div>
        </CommonModalContent>
        <SolidPrimaryBtn
          type="button"
          className="default-btn "
          onClick={handleCreateOne}
        >
          등록
        </SolidPrimaryBtn>
      </CommonModalContainer2>
    </Modal>
  );
}

// 달력 Month
const months = MONTHS;
/**
 * 할인/프로모션 모달
 * @isOpen 모달 open true/false
 * @type 등록 'create' / 수정 'edit'
 * @content 할인/프로모션 object
 * @isClose 모달 close true/false
 * @isSuccess 등록 및 수정 success true/false
 * @returns 
 */
export function PromotionModalComponent({
  isOpen,
  type,
  content,
  setPromotionOne,
  // isRefresh,
  isClose,
  isSuccess,
  emptyMsg,
}: {
  isOpen: boolean;
  type: string;
  content: DiscountInfo;
  setPromotionOne: Function;
  // isRefresh: Function;
  isClose: Function;
  isSuccess: Function;
  emptyMsg?: string;
}) {
  // console.log("content ", content);
  const { selectSiteId } = useLoginUserInfo();
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;
  const [promotionObj, setPromotionObj] = useState(content);
  const defaultPromotionObj: DiscountInfo = {
    id: 0,
    site_id: selectSiteId,
    name: "",
    rate: 0,
    price: 0,
    discount_type: 1,
    max_price: 0,
    start_date: "",
    end_date: "",
    etc: "",
  };
  const promotionType = PromotionType;
  // 수정/삭제
  const headTitle = type === "create" ? `할인/프로모션 신규등록` : `할인/프로모션 수정`;
  async function handleCreateOne() {
    const { id, ...data } = promotionObj;
    if (data.name === "" || !data.start_date || !data.end_date
      || (data.discount_type === 1 && !data.rate) || (data.discount_type === 2 && !data.price)) {
      window.alert('필수항목을 다 입력해주세요.');
      return;
    }
    // console.log("> promotionObj ", promotionObj);
    if (type === "create") {
      // 신규 등록
      const postPromotionRes = await postDiscounts(data);
      if (postPromotionRes.code === 200) {
        isClose(false);
        setPromotionObj(defaultPromotionObj);
        isSuccess(true);
        // 성공 결과 넘기기
      } else throw new Error("postPayments API error ", postPromotionRes.message);
    }else {
      // 수정
      const putPromotionRes = await putDiscounts(data, id);
      if (putPromotionRes.code === 200) {
        isClose(false);
        setPromotionObj(defaultPromotionObj);
        isSuccess(true);
        // 성공 결과 넘기기
      } else throw new Error("postPayments API error ", putPromotionRes.message);
    }
  }

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "price") {
      const regex = /\D+/gi;
      const removedCommaValue = Number(value.replaceAll(",", ""));
      if (!regex.test(String(removedCommaValue))) {
        setPromotionObj({
          ...promotionObj,
          [name]: removedCommaValue,
        });
        return;
      }
    } else if (name === "rate") {
      const regex = /^\d{0,2}$/gi;
      if (regex.test(value)) {
        setPromotionObj((prev) => ({ ...prev, [name]: Number(value) }));
        return;
      }
    } else if (name === "discount_type") {
      setPromotionObj((prev) => ({
        ...prev,
        rate: 0,
        price: 0,
        [name]: Number(value),
      }));
    } else setPromotionObj((prev) => ({ ...prev, [name]: value }));
  };
  function closeModal() {
    isClose(false);
    setPromotionObj(defaultPromotionObj);
  }
  const handleChangeDate = (data: [Date | null, Date | null]) => {
    setDateRange(data);
    setPromotionObj(prev => ({
      ...prev,
      start_date: data[0] ? `${formattedDateHyphenYYYYMMDD(data[0])} 00:00:00` : "",
      end_date: data[1] ? `${formattedDateHyphenYYYYMMDD(data[1])} 23:59:59` : "",
    }));
  }
  const changeDateRange = useCallback(() => {
    if (isOpen) {
      if (type !== "create") {
        setDateRange([
          new Date(content.start_date),
          new Date(content.end_date),
        ]);
      } else {
        setDateRange([null, null]);
      }
    }
  }, [isOpen, content.start_date, content.end_date, type]); // 필요한 의존성 추가

  useEffect(() => {
    changeDateRange();
  }, [changeDateRange]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={detailCustomStyles}
      contentLabel="detail Modal"
    >
      <CommonModalContainer2>
        <header>
          <h3>{headTitle}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <CommonModalContent>
          <div className="flex-c">
            <InputWrapC>
              <label htmlFor="name" className="required_value">할인/프로모션 내용</label>
              <input
                type="text"
                name="name"
                value={promotionObj.name}
                onChange={(event) => handleInputChange(event)}
                placeholder="할인/프로모션 내용 입력"
              />
            </InputWrapC>
            <InputWrapC>
              <p style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                <label className="required_value">이벤트 기간</label>
                <TooltipIcon content="시간은 00:00 ~ 23:59 고정입니다." />
              </p>
              <CustomDatePickerWrap className="custom-date-picker modal-datepicker">
                <ReactDatePicker
                  enableTabLoop={false}
                  dateFormat="yyyy-MM-dd (E)" // 날짜형태
                  placeholderText="이벤트 기간 선택"
                  formatWeekDay={(day) => day.substring(0, 1)}
                  shouldCloseOnSelect // 날짜 선택 시 datepicker 자동 닫힘
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => handleChangeDate(update)}
                  dropdownMode="select"
                  minDate={subYears(new Date(), 1)}
                  renderCustomHeader={({
                    date,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => (
                    <div className="custom-header-container">
                      <div>
                        <button
                          type="button"
                          onClick={decreaseMonth}
                          className="custom-month-button"
                          disabled={prevMonthButtonDisabled}
                        >
                          <img src="/image/icon/arrow_left.svg" alt="left" />
                        </button>
                        <span className="custom-year">{getYear(date)}</span>
                        <select
                          value={months[getMonth(date)]}
                          className="custom-month"
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={increaseMonth}
                          className="custom-month-button"
                          disabled={nextMonthButtonDisabled}
                        >
                          <img src="/image/icon/arrow_right.svg" alt="right" />
                        </button>
                      </div>
                    </div>
                  )}
                />
              </CustomDatePickerWrap>
            </InputWrapC>
            <InputWrapC>
              <p className="required_value">할인/프로모션 종류</p>
              <InputWrapR>
                {promotionType.map((d) => (
                  <InputWrapR key={d.value}>
                    <input
                      type="radio"
                      id={`discount_type_${d.value}`}
                      name="discount_type"
                      value={d.value}
                      onChange={(event) => handleInputChange(event)}
                      checked={promotionObj.discount_type === d.value}
                    />
                    <label htmlFor={`discount_type_${d.value}`}>
                      {d.label}
                    </label>
                  </InputWrapR>
                ))}
                {promotionObj.discount_type === 1 ? (
                  <input
                    type="text"
                    name="rate"
                    value={`${promotionObj.rate}` || ""}
                    onChange={(event) => handleInputChange(event)}
                    placeholder="할인율 입력"
                  />
                ) : (
                  <input
                    type="text"
                    name="price"
                    value={formatCurrency(promotionObj.price) || ""}
                    onChange={(event) => handleInputChange(event)}
                    placeholder="할인금액 입력"
                  />
                )}
              </InputWrapR>
            </InputWrapC>
            <InputWrapC>
              <label htmlFor="etc">비고</label>
              <input
                type="text"
                name="etc"
                value={promotionObj.etc}
                onChange={(event) => handleInputChange(event)}
                placeholder="내용 입력"
              />
            </InputWrapC>
          </div>
        </CommonModalContent>
        <SolidPrimaryBtn
          type="button"
          className="default-btn "
          onClick={handleCreateOne}
        >
          등록
        </SolidPrimaryBtn>
      </CommonModalContainer2>
    </Modal>
  );
}

export function ReceiptModalComponent({
  isOpen,
  type,
  content,
  setReceiptOne,
  isClose,
  classList,
  studentList,
  classSelectOption,
  paymentType,
  paymentList,
  discountList,
  isSuccess,
  emptyMsg,
}: {
  isOpen: boolean;
  type: string;
  content: ReceiptTotalInfo;
  setReceiptOne: Function;
  isClose: Function;
  classList: provinceInfo[];
  studentList: StudentInfo[];
  classSelectOption: provinceInfo[];
  paymentType: provinceInfo[];
  paymentList: PaymentInfo[];
  discountList: DiscountInfo[];
  isSuccess: Function;
  emptyMsg?: string;
}) {
  // console.log("type ", type);
  // console.log("content ", content);
  // console.log("classList ", classList);
  // console.log("studentList ", studentList);
  // console.log("paymentList ", paymentList);
  // console.log("discountList ", discountList);
  const { selectSiteId } = useLoginUserInfo();
  const [closeDate, setCloseDate] = useState<Date>(new Date());
  const [receiptObj, setReceiptObj] = useState(content);

  // 등록용
  const createReceiptObj: {
    site_id: number,
    student_id_list: number[],
    payment_info_id: number,
    discount_info_id: null | number,
    bill_date: string,
    close_date: string,
    send_status: number,
    etc: string,
  } = {
    site_id: selectSiteId,
    student_id_list: [0],
    payment_info_id: 0,
    discount_info_id: null,
    bill_date: getCurrentDateTime(),
    close_date: "",
    send_status: 0,
    etc: "",
  };
  const defaultReceiptTotalObj: ReceiptTotalInfo = {
    id: 0,
    site_id: selectSiteId,
    student_id: 0,
    student_name: "",
    user_id: 0,
    user_name: "",
    payment_info_id: 0,
    payment_info: undefined,
    discount_info_id: null,
    discount_info: undefined,
    pay_price: 0,
    pay_date: "",
    pay_method: null,
    on_site_payment: null,
    bill_date: getCurrentDateTime(),
    close_date: "",
    cancel_date: "",
    reg_date: "",
    approval_number: "",
    send_status: 0,
    status: 0,
    etc: "",
  };
  // 수정/삭제
  const headTitle = type === "create" ? `청구서 작성` : `청구서 수정`;

  const [studentsByClass, setStudentsByClass] = useState<provinceInfo[]>(
    formattedSelectOption(studentList.map((d: any) => ({ label: aesCBCDecrypt(d.name), value: d.id })))
  );
  const [paymentByType, setPaymentByType] = useState<provinceInfo[]>(
    formattedSelectOptionNotAll(paymentList.map((l: any) => ({ label: l.name, value: l.id })))
  );
  const [discountBySelect, setDiscountBySelect] = useState<provinceInfo[]>(
    formattedSelectOptionNotAll(discountList.map((d: any) => ({ label: d.name, value: d.id })))
  );
  // 할인항목 select 변경 막기
  const [isChangeOption, setIsChangeOption] = useState(false);
  const [selectObj, setSelectObj] = useState<{
    class_id: number[],
    student_list: number[],
    type: number,
  }>({
    class_id: [0],
    student_list: [0],
    type: 0,
  });
  // 반/학생/수납구분 changeHandler
  function handleChangeOption1(prop: any, name: string) {
    // console.log("prop ", prop, name);
    if (name === 'type') {
      setSelectObj((prev) => ({ ...prev, type: prop }));
      if (prop) {
        const _paymentList = paymentList.filter(p => p.type === prop);
        const list = _paymentList.length ? formattedSelectOptionNotAll(_paymentList.map((l: any) => ({ label: l.name, value: l.id }))) : [];
        setPaymentByType(list);
      }
      else {
        const list = formattedSelectOptionNotAll(paymentList.map((l: any) => ({ label: l.name, value: l.id })));
        setPaymentByType(list);
      }
    }
    else {
      const arr = prop.map((p: provinceInfo) => p.value);
      // console.log(arr);
      if (name === 'class') {
        if (!arr.includes(0)) {
          const classStudents = studentList.filter(s => s.class_list.some(c => arr.includes(c.id)));
          const students = formattedSelectOption(classStudents.map((d: any) => ({ label: aesCBCDecrypt(d.name), value: d.id })));
          setStudentsByClass(students);
          setSelectObj((prev) => ({ ...prev, class_id: arr }));
        }
        else {
          setStudentsByClass(formattedSelectOption(studentList.map((d: any) => ({ label: aesCBCDecrypt(d.name), value: d.id }))));
          setSelectObj((prev) => ({ ...prev, class_id: arr }));
        }
      }
      // 전체인 경우 student_id 전체 [] - 조회 누를 때
      else setSelectObj((prev) => ({ ...prev, student_list: arr }));
    }
  }
  // 수납항목/할인항목 changeHandler
  function handleChangeOption2(prop: number, name: string) {
    if (name === "payment") {
      const selectPayment = paymentList.find(payment => payment.id === prop);
      setReceiptObj((prev) => ({ ...prev, payment_info_id: prop, payment_info: selectPayment }));
      setReceiptObj((prev) => ({ ...prev, discount_info_id: null, discount_info: undefined }));
      setIsChangeOption(true);
    }
    else if (name === "discount") {
      if (receiptObj.payment_info_id === 0) {
        alert('수납 항목을 먼저 선택해주세요.');
        setIsChangeOption(false);
        return;
      }
      else if (receiptObj.payment_info_id !== 0 && receiptObj.payment_info?.discount_status === 0) {
        alert('할인이 불가능한 항목입니다.');
        setIsChangeOption(false);
        return;
      }
      else {
        const selectDiscount = discountList.find(discount => discount.id === prop);
        setReceiptObj((prev) => ({ ...prev, discount_info_id: prop, discount_info: selectDiscount }));
      }
    }
  }
  // 청구서 작성/수정
  async function handleCreateOne() {
    // 신규 등록
    if (type === "create") {
      if (!selectObj.class_id.length || !selectObj.student_list.length) {
        alert('반 또는 학생를 선택해주세요.');
        return;
      }
      else if (!receiptObj.payment_info_id) {
        alert('수납항목을 선택해주세요.');
        return;
      }
      if (selectObj.class_id.some(id => id === 0) && selectObj.student_list.some(id => id === 0)) {
        // 전체/전체인 경우 student_list에 전체 학생 id push
        createReceiptObj.student_id_list = studentList.filter(s => s.id !== 0).map(s => s.id);
      }
      else if (!selectObj.class_id.some(id => id === 0) && selectObj.student_list.some(id => id === 0)) {
        // 반 선택/전체인 경우 해당 반의 학생 id 전체 push
        const selectStudent = studentList.filter(s => s.id !== 0)
          .filter(s => s.class_list.some(c => selectObj.class_id.includes(c.id))).map(s => s.id);
        createReceiptObj.student_id_list = selectStudent;
      }
      else {
        // 그 외
        createReceiptObj.student_id_list = selectObj.student_list;
      }
      createReceiptObj.close_date = getCurrentDateTime(closeDate);
      createReceiptObj.payment_info_id = receiptObj.payment_info_id;
      if (receiptObj.discount_info_id) createReceiptObj.discount_info_id = receiptObj.discount_info_id;
      else createReceiptObj.discount_info_id = 0;
      const createRes = await postReceipt(createReceiptObj);
      // console.log("> ", createRes);

      if (createRes.code === 200) {
        isClose(false);
        setReceiptObj(defaultReceiptTotalObj);
        isSuccess(true);
        // 성공 결과 넘기기
      } else throw new Error("postReceipt API error ", createRes.message);
    }
    // 수정
    else {
      setReceiptObj((prev) => ({
        ...prev,
        close_date: getCurrentDateTime(closeDate),
      }));
    }
  }
  // 결제 수단
  function handleChangePayMethod(prop: number) {
    // console.log("prop ", prop, name);
  }
  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "discount_price" || name === "cost") {
      const regex = /\D+/gi;
      const removedCommaValue = Number(value.replaceAll(",", ""));
      if (!regex.test(String(removedCommaValue))) {
        setReceiptObj({
          ...receiptObj,
          [name]: removedCommaValue.toLocaleString(),
        });
        return;
      }
    } else if (name === "rate") {
      const regex = /^\d{1,2}$/gi;
      if (regex.test(value)) {
        setReceiptObj((prev) => ({ ...prev, [name]: Number(value) }));
        return;
      }
    } else if (name === "discount_type") {
      setReceiptObj((prev) => ({
        ...prev,
        rate: 0,
        discount_price: 0,
        [name]: Number(value),
      }));
    } else setReceiptObj((prev) => ({ ...prev, [name]: value }));
  };
  function closeModal() {
    isClose(false);
    setReceiptObj(defaultReceiptTotalObj);
  }
  useEffect(() => {
    // console.log('receiptObj ', receiptObj);
    if (receiptObj.payment_info_id !== 0 && receiptObj.payment_info?.discount_status === 0) {
      setIsChangeOption(false);
    }
  }, [receiptObj]);
  // useEffect(() => {
  //   console.log("> selectObj ", selectObj);
  // }, [selectObj]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={notOverflowHiddenCustomStyles}
      contentLabel="detail Modal"
    >
      <CommonModalContainer2>
        <header>
          <h3>{headTitle}</h3>
          <img src="/image/icon/close.svg" alt="close" onClick={closeModal} />
        </header>
        <CommonModalContent>
          <div className="flex-c">
            <CustomDatePickerWrap className="custom-date-picker modal-datepicker not-range">
              <label style={{ width: "30%" }}>납기 만료일</label>
              <ReactDatePicker
                enableTabLoop={false}
                dateFormat="yyyy-MM-dd (E)" // 날짜형태
                placeholderText="납기 만료일 선택"
                formatWeekDay={(day) => day.substring(0, 1)}
                shouldCloseOnSelect // 날짜 선택 시 datepicker 자동 닫힘
                todayButton="오늘"
                selected={closeDate}
                onChange={(date) => setCloseDate(date || new Date())}
                dropdownMode="select"
                minDate={subYears(new Date(), 1)}
                maxDate={addMonths(new Date(), 2)}
                dayClassName={(d) =>
                  d.getDate() === closeDate?.getDate()
                    ? "selectedDay"
                    : "unSelectedDay"
                }
                renderCustomHeader={({
                  date,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => (
                  <div className="custom-header-container">
                    <div>
                      <button
                        type="button"
                        onClick={decreaseMonth}
                        className="custom-month-button"
                        disabled={prevMonthButtonDisabled}
                      >
                        <img src="/image/icon/arrow_left.svg" alt="left" />
                      </button>
                      <span className="custom-year">{getYear(date)}</span>
                      <select
                        value={months[getMonth(date)]}
                        className="custom-month"
                        onChange={({ target: { value } }) =>
                          changeMonth(months.indexOf(value))
                        }
                      >
                        {months.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={increaseMonth}
                        className="custom-month-button"
                        disabled={nextMonthButtonDisabled}
                      >
                        <img src="/image/icon/arrow_right.svg" alt="right" />
                      </button>
                    </div>
                  </div>
                )}
              />
            </CustomDatePickerWrap>
            <InputWrapR>
              <InputWrapC>
                <label className="required_value">반</label>
                <MultipleSelectOption
                  optionData={classSelectOption}
                  onChange={(prop: number) => handleChangeOption1(prop, 'class')}
                />
              </InputWrapC>
              <InputWrapC>
                <label className="required_value">학생</label>
                <MultipleSelectOption
                  optionData={studentsByClass}
                  onChange={(prop: number) => handleChangeOption1(prop, 'student')}
                />
              </InputWrapC>
            </InputWrapR>
            <InputWrapR>
              <InputWrapC style={{ width: "30%" }}>
                <label>수납 구분</label>
                <SelectOption
                  optionData={paymentType}
                  onChange={(prop: number) =>
                    handleChangeOption1(prop, "type")
                  }
                />
              </InputWrapC>
              <InputWrapC style={{ width: "70%" }}>
                <label className="required_value">수납 항목</label>
                <SelectOption
                  optionData={paymentByType}
                  onChange={(prop: number) => handleChangeOption2(prop, 'payment')}
                />
              </InputWrapC>
            </InputWrapR>
            <InputWrapR>
              <InputWrapC style={{ width: "70%" }}>
                <label>할인/프로모션 항목</label>
                <SelectOption
                  optionData={discountBySelect}
                  onChange={(prop: number) =>
                    handleChangeOption2(prop, "discount")
                  }
                  dontChange={!isChangeOption}
                />
              </InputWrapC>
              <InputWrapC style={{ width: "30%" }}>
                {(receiptObj.discount_info_id !== 0 && receiptObj.discount_info?.discount_type === 1) ?
                  <>
                    <label>할인율</label>
                    <input
                      type="text"
                      name="rate"
                      value={`${receiptObj.discount_info.rate}%` || 0}
                      disabled
                    />
                  </>
                  : (receiptObj.discount_info_id !== 0 && receiptObj.discount_info?.discount_type === 2) ?
                    <>
                      <label>할인금액</label>
                      <input
                        type="text"
                        name="discount_price"
                        value={`${formatCurrency(receiptObj.discount_info.price)}원` || 0}
                        disabled
                      />
                    </>
                    :
                    <>
                      <label>할인율/금액</label>  
                      <input
                        type="text"
                        value={0}
                        placeholder="할인/프로모션 항목 선택"
                        disabled
                      />
                    </>
                }
              </InputWrapC>
            </InputWrapR>
            <InputWrapR>
              <InputWrapC>
                <label htmlFor="price">수납 금액(원)</label>
                <input
                  type="text"
                  name="cost"
                  value={receiptObj.payment_info ? formatCurrency(receiptObj.payment_info.price) : 0 || 0}
                  placeholder="수납 항목 선택"
                  disabled
                />
              </InputWrapC>
              <InputWrapC>
                <label htmlFor="pay_price">최종 수납 금액(원)</label>
                <input
                  type="text"
                  name="pay_price"
                  value={receiptObj.payment_info ?
                    ( receiptObj.payment_info.discount_status === 0 ? formatCurrency(receiptObj.payment_info.price)
                      : (receiptObj.discount_info ?
                          (receiptObj.discount_info.discount_type === 1 ?
                            formatCurrency((receiptObj.payment_info.price * ((100 - receiptObj.discount_info.rate) / 100)))
                            : formatCurrency(receiptObj.payment_info.price - receiptObj.discount_info.price)
                          ) : 0)
                    ) : 0 }
                  placeholder="수납 항목과 할인/프로모션 항목을 선택해주세요."
                  disabled
                />
              </InputWrapC>
            </InputWrapR>
            {type === 'edit' && (
              <>
                <details>
                  <summary>결제 정보</summary>
                  <InputWrapC>
                    <InputWrapR style={{ alignItems: "flex-end" }}>
                      <InputWrapC style={{ width: "70%" }}>
                        <label>결제 수단</label>
                        <SelectOption
                          optionData={PayMethodType}
                          onChange={(prop: number) => handleChangePayMethod(prop)}
                        />
                      </InputWrapC>
                      <input
                        type="text"
                        name="pay_price"
                        value={''}
                        onChange={(event) => handleInputChange(event)}
                        placeholder="결제 금액 입력"
                      />
                      <InputWrapR style={{ width: "30%", justifyContent: "flex-end" }}>
                        <input
                          type="checkbox"
                          id="payment_on_site"
                          name="payment_on_site"
                          onChange={(event) => handleInputChange(event)}
                        />
                        <label htmlFor="payment_on_site">현장 수납</label>
                      </InputWrapR>
                    </InputWrapR>
                    <InputWrapC>
                      <label htmlFor="etc">비고</label>
                      <input
                        type="text"
                        name="payment_etc"
                        value={''}
                        onChange={(event) => handleInputChange(event)}
                        placeholder="내용 입력"
                      />
                    </InputWrapC>
                    <SolidRedBtn
                      type="button"
                      className="default-btn "
                      onClick={handleCreateOne}
                      disabled={receiptObj.status !== 2}
                    >
                      결제 취소
                    </SolidRedBtn>
                  </InputWrapC>
                </details>
              </>
            )}
          </div>
        </CommonModalContent>
        <SolidPrimaryBtn
          type="button"
          className="default-btn "
          onClick={handleCreateOne}
        >
          등록
        </SolidPrimaryBtn>
      </CommonModalContainer2>
    </Modal>
  );
}
